import { useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import { FormInput } from "@/shared/components";

export function LastName(props: { pending: boolean }) {
  const { pending } = props;

  const {
    formState: { errors },
  } = useFormContext();

  const getErrorText = () => {
    if (
      errors.last_name?.type === "required" ||
      errors.last_name?.type === "validate"
    ) {
      return "This field must contain 2-100 symbols";
    }

    return null;
  };

  return (
    <FormInput
      name="last_name"
      rules={{
        required: true,
        validate: (value) => {
          const trimmedValue = (value || "").trim();
          const validValue =
            trimmedValue.length >= 2 && trimmedValue.length <= 100;

          return validValue;
        },
      }}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          label="Last name"
          variant="filled"
          disabled={pending}
          error={!!getErrorText()}
          helperText={getErrorText()}
        />
      )}
    />
  );
}
